import { useSelector } from "react-redux";
import ComboBox from "../../Control/ComboBox/ComboBox";
import { ColumnLabel } from "../../Layout/ColumnLabel";
import { RootState } from "../../../store";
import { AppState } from "../../../appSlice";
import { useEffect, useState } from "react";
import { ComboBoxOption } from "../../../models/Input";

export type ArtistSelectorProps = {
    values: ComboBoxOption<string> | null,
    update: (values: ComboBoxOption<string> | null) => void
}

export function ArtistSelector(props: ArtistSelectorProps) {
    const { artists } = useSelector<RootState, AppState>(x => x.app);
    const [artistOptions, setArtistOptions] = useState<ComboBoxOption<string>[]>([]);

    useEffect(() => {
        setArtistOptions(artists.map(x => ({ label: x, value: x })));
    }, [artists]);


    return (
        <ColumnLabel label="Artists">
            <ComboBox
                selections={props.values}
                isMulti={false}
                isClearable={true}
                options={artistOptions}
                onChange={(newSelections) => props.update(newSelections)} />
        </ColumnLabel>
    )
}